/**
 * PortalLayout — §14.3 "(portal)" layout.
 * Sidebar navigation on desktop; the compact topbar falls back on small screens.
 * Used by external faculty/vendor portal routes.
 */

import { Outlet } from 'react-router-dom';

import PortalSidebar from '@/components/layout/PortalSidebar';
import PortalTopbar from '@/components/layout/PortalTopbar';
import PortalHelpLink from '@/components/layout/PortalHelpLink';
import CreatedByCredit from '@/components/layout/CreatedByCredit';
import RequireUserType from '@/components/auth/RequireUserType';

export default function PortalLayout() {
  return (
    // Defense-in-depth: internal staff cannot load the (portal) shell by URL —
    // they are bounced to /dashboard. Backend RBAC remains the real security
    // boundary; this is UX + belt-and-suspenders only.
    <RequireUserType allow="external">
      <div className="flex min-h-screen bg-background">
        {/* Desktop sidebar */}
        <PortalSidebar className="hidden md:flex" />

        <div className="flex min-w-0 flex-1 flex-col">
          {/* Mobile top nav */}
          <div className="md:hidden">
            <PortalTopbar />
          </div>

          {/* Desktop action bar — Help top-right, mirroring the internal app's
              topbar. On mobile the same link lives in PortalTopbar. */}
          <header className="hidden h-16 shrink-0 items-center justify-end border-b border-border bg-card px-6 md:flex">
            <PortalHelpLink />
          </header>

          <main className="flex-1 p-6">
            <div className="mx-auto max-w-5xl">
              <Outlet />
            </div>
          </main>

          <footer className="border-t border-border px-6 py-4 text-center text-xs text-muted-foreground">
            <p>&copy; {new Date().getFullYear()} NIRC of ICAI — Faculty &amp; Vendor Portal</p>
            <CreatedByCredit className="mt-1" />
          </footer>
        </div>
      </div>
    </RequireUserType>
  );
}
